import React from "react";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button,
  Form,
  
} from "shards-react";
import { Link } from "react-router-dom";
import TableRow from '../layout/TableRow';
import TableColumnRow from '../layout/TableColumnRow';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FcAcceptDatabase,FcDataConfiguration } from "react-icons/fc";
import ProjectStructureDataService from "../../services/projectStructure.service";
import ProcessFileService from "../../services/processFile.service";
import { FcApproval } from "react-icons/fc";
import moment from "moment";
import {actions as AppActions} from "../../_stores/app.store";

const INDIA = process.env.REACT_APP_MARKET === "INDIA";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";

const columnIndex = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];


class ProjectStructureDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectDetails:"",
      fileType:"",
      fileFormat:"",
      projectStructureName: "",
      skipRows: "",
      dataHeaderRow: "",
      validationColumn: "",
      exceptionKeywords: "",
      // exceptionKeywords: "SUTURE, USYNTH",
      sourceTargetColumnMapping: [],
      rows:"",
      columnsRows:"",
      columnsRowsMapping:"",
      headers:"",
      viewTable:false,
      masterTableFields:[],
      rowNoToremove: [],
      file: null,
      suppliernameRow: 1,
      supplierLocationRow: 2,
      reportTypeRow: 3,
      reportPeriodRow: 5,
      // inputTemplateheaderRow: 5,
      selectedReport: 'report1',
      templateName: 'report1',
      fileUploaded:false,
      fileName: "",

      showSeparator: false,
      showStartDateIndex: false,
      showEndDateIndex: false,
      showSupplierCodeIndex: false,

      showSupplierName : false,
      showSupplierStatmentPeriodRow: false,
      showSkipRows: false,
      shoDataHeaderRow: false,
      hasHeader: false
    };

    this.testRun = this.testRun.bind(this);
    this.showTable = this.showTable.bind(this);
    this.clearData = this.clearData.bind(this);
    
    
  }

  componentDidMount() {
    if(this.props.projectStructureId)
    this.retrieveProjectStructureDetails();

    this.showTable()
  }

  componentDidUpdate(prevProps) {
    if (this.props.projectStructureId != prevProps.projectStructureId)
      this.retrieveProjectStructureDetails();
  }


  retrieveProjectStructureDetails(){
		ProjectStructureDataService.get(this.props.projectStructureId).then((response) => {
      var projectStructureDetails = response.data.data;
      
      var resultArr = [];
      resultArr.push(projectStructureDetails)

      this.setState({
        id: projectStructureDetails.id,
        jProjectStructureDetails: projectStructureDetails, //this is used for sending to viewrawdata
        projectStructureDetails: resultArr,
        file:projectStructureDetails.file,
        
        viewTable: false,
        projectStructureName: projectStructureDetails.projectStructureName,
        fileType: projectStructureDetails.fileType,
        fileFormat: projectStructureDetails.fileFormat,
        skipRows: projectStructureDetails.skipRows,
        dataHeaderRow: projectStructureDetails.dataHeaderRow,
        mergedCell: projectStructureDetails.mergedCell,
        validationColumn: projectStructureDetails.validationColumn,
        exceptionKeywords: projectStructureDetails.exceptionKeywords,
        separator :projectStructureDetails.separator,
        startDate: projectStructureDetails.startDate,
        endDate: projectStructureDetails.endDate,
        supplierCode: projectStructureDetails.supplierCode,
        supplierNameRow: projectStructureDetails.supplierNameRow,
        reportPeriodRow: projectStructureDetails.supplierStatmentPeriodRow,
        fileName: projectStructureDetails.file,
        supplierName: projectStructureDetails.supplierName,
        reportPeriodRange: projectStructureDetails.reportPeriodRange,
        masterTableFields:projectStructureDetails.sourceTargetColumnMapping,
        fileFormatId: projectStructureDetails.fileFormatId,
        companyNameInColumns: projectStructureDetails.companyNameInColumns,
        sourceTargetColumnMapping: projectStructureDetails.sourceTargetColumnMapping,
        hasHeader: projectStructureDetails.hasHeader,
			});

      if(projectStructureDetails.fileType === "textFile")
    {
      if(projectStructureDetails.hasHeader){
        this.setState({
          separator :"",
          startDate: "",
          endDate: "",
          supplierCode: "",
  
          showSupplierName : true,
          showSupplierStatmentPeriodRow: true,
          showSkipRows: true,
          shoDataHeaderRow: true,
          
          showseparator: false,
          showStartDateIndex: false,
          showEndDateIndex: false,
          showSupplierCodeIndex: false
        });
      } else {
        this.setState({

          supplierName : "",
          supplierStatmentPeriodRow: "",
          skipRows: "",
          dataHeaderRow: "",

          showSupplierName : false,
          showSupplierStatmentPeriodRow: false,
          showSkipRows: false,
          shoDataHeaderRow: false,

          showSeparator: true,
          showStartDateIndex: true,
          showEndDateIndex: true,
          showSupplierCodeIndex: true,

        });
      }
    }else if(projectStructureDetails.fileType === "excelFile"){
      this.setState({
       
        separator :"",
        startDate: "",
        endDate: "",
        supplierCode: "",

        showSupplierName : true,
        showSupplierStatmentPeriodRow: true,
        showSkipRows: true,
        shoDataHeaderRow: true,
        
        showSeparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false
      });
    }else{
      this.setState({
       
        supplierName : "",
        supplierStatmentPeriodRow: "",
        skipRows: "",
        dataHeaderRow: "",

        showSupplierName : false,
        showSupplierStatmentPeriodRow: false,
        showSkipRows: false,
        shoDataHeaderRow: false,

        separator :"",
        startDate: "",
        endDate: "",
        supplierCode: "",
        
        showSeparator: false,
        showStartDateIndex: false,
        showEndDateIndex: false,
        showSupplierCodeIndex: false


        });
      }

  	});
	}

   testRun(){
    this.viewOriginalFile();
  }


 
  viewOriginalFile(file) {

    const { fileName } = this.state;
    let finalFileName = fileName;
    if(file){
      finalFileName = file.name;
    }
    
    if(finalFileName){

      AppActions.setLoading(true);
      const { sourceTargetColumnMapping } = this.state;

      const state = { ...this.state };
      delete state.masterTableFields;
      delete state.projectStructureList;
      delete state.supplierFilteredList;
      delete state.supplierList;

      
      ProcessFileService.viewOriginalFile({state: state, fileName: finalFileName, projectId: this.props.projectId  }).then((response) => {
        AppActions.setLoading(false);
        if(sourceTargetColumnMapping.length > 0){
          this.setState({ rows: response.data.output, headers: response.data.output.headerData, fileUploaded: true});
        } else {
          this.setState({ headers: response.data.output.headerData, fileUploaded: true});
        }
        
     this.setState({
       testRunBtn: true,
    	});

        this.showTable();
      });

    } else {
      console.error('No File Name Provided');
    }

    
  }


  clearData(){
    localStorage.clear();
    this.setState({
      rows: ""
		});
  }

  showTable(){
    //alert();
    this.setState({
      viewTable: true,
		});

  }


  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}


  render() {
    
    const {
      id,
        clearData,
         headers,
         viewTable,
         projectDetails,
         masterTableFields,
         fileUploaded,
         fileName,
         file,
         projectStructureDetails,
         showSeparator,
          showStartDateIndex,
          showEndDateIndex,
          showSupplierCodeIndex,
          showSupplierName,
          showSupplierStatmentPeriodRow,
          showSkipRows,
          shoDataHeaderRow,
      // PostsListFour
    } = this.state;

    const {
      projectId,
      projectStructureId
    // PostsListFour
  } = this.props;

  //const id = this.state.projectFileDetails && this.state.projectFileDetails[0] && this.state.projectFileDetails[0].id;
  const totalRowProcessed = this.state.rows.rowData && this.state.rows.rowData.length > 0 ? this.state.rows.rowData.length : 0 || 0;
  const totalRowCount = this.state.rows.totalRowCount || 0;
  const totalEmptyRowCount = this.state.rows.totalEmptyRowCount || 0;

    return (
    <div>
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">
            Create New Project Structure Definition
            <Link className="btn btn-primary ml-4" to={"/project/"+projectId+"/structure"}><FcAcceptDatabase /> View All</Link>
            {
              id && (<Link className="btn btn-primary ml-4" to={`/project/${projectId}/structure/${id}/edit`}><FcAcceptDatabase /> Edit</Link>)
            }
          </h6>
        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="">
            <Form>
            {projectStructureDetails && projectStructureDetails.map(function (item,index){
              return(
              <Row form key={index+1}>
                {/* First Name */}
                <Col md="12" className="form-group">
                   <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="fileType">File Type</label></Col>
                      <Col className="form-field" md="8">{item.fileType}</Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="fileFormat">File Format</label></Col>
                      <Col className="form-field" md="8">{item.fileFormat}</Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="projectStructureName">Structure Name</label></Col>
                      <Col className="form-field" md="8">{item.projectStructureName}</Col>
                    </Row>
                 
                    {showSeparator && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Separator</label></Col>
                        <Col className="form-field" md="8">{item.separator}</Col>
                      </Row>
                      )
                    }
                    {showSupplierCodeIndex && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Code Index</label></Col>
                        <Col className="form-field" md="8">{item.supplierCode}</Col>
                      </Row>
                      )
                    }
                    {showStartDateIndex && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Start Date Index</label></Col>
                        <Col className="form-field" md="8">{item.startDate}</Col>
                      </Row>
                      )
                    }
                    {showEndDateIndex && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierNameRow">End Date Index</label></Col>
                        <Col className="form-field" md="8">{item.endDate}</Col>
                      </Row>
                      )
                    }

                    {INDIA && showSupplierName && (
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Name Row</label></Col>
                      <Col className="form-field" md="8">{item.supplierNameRow}</Col>
                    </Row>
                      )
                    }

                    {INDIA && showSupplierStatmentPeriodRow && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierStatmentPeriodRow">Supplier Statement period Row</label></Col>
                        <Col className="form-field" md="8">{item.supplierStatmentPeriodRow}</Col>
                      </Row>
                      )
                    } 

                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInColumns">Compnay Name In Columns</label></Col>
                        <Col className="form-field" md="8">{item.companyNameInColumns === true ? 'True' : 'False'}</Col>
                      </Row>
                    )}
                    

                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="compnayNameInColumns">Compnay Name In Rows</label></Col>
                        <Col className="form-field" md="8">{item.companyNameInRows === true ? 'True' : 'False'}</Col>
                      </Row>
                    )}
                    

                    {showSkipRows && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="skipRows">Skip Rows</label></Col>
                        <Col className="form-field" md="8">{item.skipRows}</Col>
                      </Row>
                    )
                    }

                   {shoDataHeaderRow && (
                        <Row  className="form-group-row">
                          <Col className="form-label" md="4"><label htmlFor="dataHeaderRow">Data Header Row</label></Col>
                          <Col className="form-field" md="8">{item.dataHeaderRow}</Col>
                        </Row>
                      )
                    }

                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="validationColumn">Validation Column</label></Col>
                      <Col className="form-field" md="8">{item.validationColumn}</Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="exceptionKeywords">Exception Keywords</label></Col>
                      <Col className="form-field" md="8">{item.exceptionKeywords}</Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="feFirstName">Selected File</label></Col>
                      <Col className="form-field" md="8">
                        {projectStructureId && (
                          <div><FcApproval /> Uploaded Name : 
                          <Link to={"/uploads/"+file} target="_blank" download>{file}</Link></div>
                        )}
                        {fileUploaded && (
                          <div><FcApproval /> File Name : {file.name}</div>
                        )}
                      </Col>
                    </Row>
                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">Supplier Name</label></Col>
                        <Col className="form-field" md="8">{item.supplierName}</Col>
                      </Row>
                    )}
                    
                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">Report Date Range </label></Col>
                        <Col className="form-field" md="8">{item.reportPeriodRange}</Col>
                      </Row>
                    )}

                    {(SAUDI || EGYPT) && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="fileDateFormat">File Date Format</label></Col>
                        <Col className="form-field" md="8">{item.fileDateFormat}</Col>
                      </Row>
                    )}
                    
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="createdAt">Created Date </label></Col>
                      <Col className="form-field" md="8">{moment(new Date(item.createdAt)).format("DD/MM/yyyy hh:mm:ss A")}</Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="createdBy">Modified By </label></Col>
                      <Col className="form-field" md="8">{!(item.modifiedBy && !item.modifiedBy.name) ? "admin" : item.modifiedBy.name}</Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-field font-bold" md="12"><label htmlFor="feFirstName">Source Target Column Mapping</label></Col>
                    </Row>
                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="source">Source</label></Col>
                      <Col className="form-label" md="4"><label htmlFor="target">Target</label></Col>
                      <Col className="form-label" md="4"><label htmlFor="columnLevelTransformation">Column Level Transformation</label></Col>
                      {/* <Col className="form-label" md="4"><label htmlFor="computedColumn">Computed Column</label></Col> */}
                    </Row>
                    {item.sourceTargetColumnMapping && item.sourceTargetColumnMapping.map((mitem,mindex) => {
                      return(
                      <Row className="form-group-row" key={mindex+1}>
                        <Col className="form-label" md="4"><label htmlFor="feFirstName">{mitem.fieldName}</label></Col>
                        <Col className="form-label" md="4">{mitem.target == "Select Target Field" ? "" :  mitem.target}</Col>
                        <Col className="form-field" md="4">{mitem.columnLevelTransformation}</Col>
                        {/* <Col className="form-field" md="4">{mitem.computedColumn}</Col> */}
                      </Row>
                        )
                      })
                    }
                    
                </Col>
              </Row>

             
              )
            })
            }
            
              <Row  className="form-row">
                <Col className="form-button" md="4">
                  <Button variant="primary" className="btn btn-primary float-left mr-3" onClick={this.testRun}> Test Run</Button>
                  {/* <button className="btn btn-primary" onClick={() => this.proccessFile()} theme="accent"><FcDataConfiguration /> Test Run</button> */}
                  {`Total Rows Count: ${totalRowCount}`}
                  <br />
                  {`Total Empty Rows Count: ${totalEmptyRowCount}`}
                  <br />
                  {`Total Rows processed: ${totalRowProcessed}`}
                </Col>
              </Row>  
            </Form>
            {viewTable && (
              <>
            <Container>
                    <Row>
                        <TableColumnRow
                            rows={this.state.columnsRows}
                            headers={this.state.headers}
                            clearData={clearData}
                        />
                    </Row>
                </Container>
              
              <Container className="mt-3">
                  <Row>
                      <TableRow
                          rows={this.state.rows}
                          clearData={clearData}
                      />
                  </Row>
              </Container>
              </>
              )
           }
           
          </ListGroupItem>
        </ListGroup>
        <ToastContainer />
      </Card>
      
    </div>
    )
  }
}


export default ProjectStructureDetail;
